import { Typography } from '@material-ui/core';
import { Backdrop } from '@room-match/shared-ui-components';
import { FrontLayout } from 'components';
import { parse } from 'query-string';
import { useEffect, useState } from 'react';
import { accountService } from 'shared/services/accountService';
import { useStyles } from './DeleteAccount.styles';

const { deleteAccountConfirmation } = accountService();
const DeleteAccount = () => {
  const { mutateAsync, isLoading } = deleteAccountConfirmation();
  const [token, settoken] = useState('');
  const [deleteFailedMessage, setdeleteFailedMessage] = useState('Invalid Token');
  const classes = useStyles();

  useEffect(() => {
    const queryParams = location.search;
    if (queryParams) {
      const token = parse(queryParams)?.delete_token as string;
      settoken(token);
      if (token) {
        (async (token: string) => {
          mutateAsync(
            { delete_token: token },
            {
              onSuccess: () => {
                setdeleteFailedMessage('');
              },
            },
          );
        })(token);
      }
    }
  }, []);

  if (isLoading) return <Backdrop isLoading={true} />;

  return (
    <FrontLayout containerWidth={1000}>
      <div className={classes.mainCont}>
        {deleteFailedMessage ? (
          <div className={classes.messageCont}>
            <Typography style={{ fontWeight: 600, fontSize: 24 }}>Account Deletion Failed</Typography>
            <Typography style={{ fontWeight: 400, fontSize: 18, marginTop: 20 }}>{deleteFailedMessage}</Typography>
          </div>
        ) : (
          <div className={classes.messageCont}>
            <Typography style={{ fontWeight: 600, fontSize: 24 }}>Account Deletion Success</Typography>
            <Typography style={{ fontWeight: 400, fontSize: 18, marginTop: 20 }}>
              You have successfully deleted your account.
            </Typography>
          </div>
        )}
      </div>
    </FrontLayout>
  );
};

export default DeleteAccount;
